module.exports = __webpack_public_path__ + "img/gsyh.c03c5da1.png";